import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ProductFundingInitType, productFundingInitState } from './state';
import { dateFormatter } from 'src/utils/dateFormatter';
import client from 'src/api/client';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { ProductOld } from 'src/admin-entity/interface/product/product-old.interface';
import { AppState } from 'src/store';
import { BASE_URL } from 'src/config/api';

export const getProductFundingListSearchURL = (state: ProductFundingInitType, baseUrl: string): string => {
    const { page, take, distributorName, productName, productOptionName, saleType, productStatus } = state;

    const url = new URL(baseUrl);
    // url.searchParams.append('startDate', dateFormatter(new Date(startDate), 'YYYY-MM-DD'));
    // url.searchParams.append('endDate', dateFormatter(new Date(endDate), 'YYYY-MM-DD'));
    url.searchParams.append('page', `${page}`);
    url.searchParams.append('take', `${take}`);

    url.searchParams.append('productType', `2`);
    if (productName) {
        url.searchParams.append('productName', productName);
    }
    if (distributorName) {
        url.searchParams.append('distributorName', distributorName);
    }
    if (productOptionName) {
        url.searchParams.append('productOptionName', productOptionName);
    }
    if (saleType) {
        url.searchParams.append('saleType', saleType);
    }
    if (productStatus) {
        url.searchParams.append('productStatus', productStatus);
    }

    return url.toString();
};

export const getProductFundingList = createAsyncThunk(
    `productFundingSlice/getProductFundingList`,
    async (_, { getState, rejectWithValue }) => {
        try {
            const state = (getState() as AppState).funding;
            const url = getProductFundingListSearchURL(state, `${BASE_URL}/v1/admin/products/search`);
            const res = await client.get<{ products: ProductOld[]; page: { count: number } }>(url.toString());
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const productFundingSlice = createSlice({
    name: 'productFundingSlice',
    initialState: productFundingInitState,
    reducers: {
        init: () => {
            return { ...productFundingInitState };
        },
        searchUrl: state => {
            const url = getProductFundingListSearchURL(state, `${window.location.origin}/product/funding/list`);
            window.history.pushState({}, '', url);
            window.dispatchEvent(new PopStateEvent('popstate'));
        },
        setSearchValues: (state, action: PayloadAction<string>) => {
            const params = new URLSearchParams(action.payload);
            // state.startDate = params.get('startDate');
            // state.endDate = params.get('endDate');
            state.page = +params.get('page');
            state.take = +params.get('take');
            const productName = params.get('productName');
            const distributorName = params.get('distributorName');
            const productOptionName = params.get('productOptionName');
            const saleType = params.get('saleType');
            const productStatus = params.get('productStatus');

            if (productName) {
                state.productName = productName;
            }
            if (distributorName) {
                state.distributorName = distributorName;
            }
            if (productOptionName) {
                state.productOptionName = productOptionName;
            }
            if (saleType) {
                state.saleType = saleType;
            }
            if (productStatus) {
                state.productStatus = productStatus;
            }
        },
        updateProductName: (state, action: PayloadAction<string>) => {
            state.productName = action.payload;
        },
        updateDistributorName: (state, action: PayloadAction<string>) => {
            state.distributorName = action.payload;
        },
        updateProductOptionName: (state, action: PayloadAction<string>) => {
            state.productOptionName = action.payload;
        },
        updateSaleStatus: (state, action: PayloadAction<string>) => {
            state.productStatus = action.payload;
        },
        updateSaleType: (state, action: PayloadAction<string>) => {
            state.saleType = action.payload;
        },
        updatePage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        updateTake: (state, action: PayloadAction<number>) => {
            state.take = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getProductFundingList.fulfilled, (state, { payload }) => {
            state.searchResult = payload;
        });
    },
});

export const {
    init,
    searchUrl,
    setSearchValues,
    updateDistributorName,
    updateProductName,
    updateProductOptionName,
    updateSaleStatus,
    updateSaleType,
    updatePage,
    updateTake,
} = productFundingSlice.actions;
export default productFundingSlice.reducer;
